import React, {useEffect, useRef, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import {useParams} from "react-router-dom";
import Api from '../Api.js'
import moment from "moment";
import {useNavigate} from "react-router-dom";
import {Col, Row} from "react-bootstrap";
import user from "../assets/img/usermiddle.png"
import send from "../assets/img/send-mail.svg"
import {useDispatch, useSelector} from "react-redux";
import {connectChatSocket, disconnectChatSocket} from "../helpers/chatSocket.js";
import {notificationCommentAddLocalRequest} from "../store/actions/notification.js";
const token = localStorage.getItem('token')
const userId = localStorage.getItem('user_id')
function NotificationPage(props) {
    const [comment, setComment] = useState("");
    const [file, setFile] = useState("");
    const [filePreviewUrl, setFilePreviewUrl] = useState("");
    // const [data, setData] = useState({notification_comment: []});
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const chatContainer = useRef(null);
    const employee = useSelector(state => state.manager.employee);
    const data = useSelector(state => state.notification.comment);

    const {id} = useParams();
    useEffect(() => {
        connectChatSocket(id, token, dispatch, userId);

        return () => {
            disconnectChatSocket(id);
        };
    }, [id]);
    useEffect(() => {
        getNotificationByIdFunc();
    }, []);

    useEffect(() => {
        if (chatContainer.current) {
            chatContainer.current.scrollTop = chatContainer.current.scrollHeight;
        }
    }, [data.notification_comment.length]);


    const getNotificationByIdFunc = async () => {
        try {
            const {data} = await Api.getNotificationSingle(id);
            const userId = localStorage.getItem("id");
            const profession = localStorage.getItem("profession");

            const updatedData = {...data};

            if (profession !== "manager") {
                updatedData.accountants.push(`https://192.168.1.115:18000/api/accountant/${userId}/`);
            } else {
                updatedData.managers.push(`https://192.168.1.115:18000/api/manager/${userId}/`);
            }

            await Api.putNotificationSingle(id, updatedData);
            const res = await Api.getNotificationSingle(id);
            dispatch(notificationCommentAddLocalRequest(res.data))


            // setData(res.data);
        } catch (error) {
            console.error("Error fetching or updating notification:", error);
        }
    };

    const raiseInvoiceClicked = (fileUrl) => {
        window.open(fileUrl, '_blank');
    };

    const sendComment = async () => {
        if (comment.trim().length > 0 || file) {
            const formData = new FormData();
            formData.append("file_url", file);
            formData.append("file_name", file.name);
            formData.append("comment", comment);
            formData.append("notification", data.url);

            if (localStorage.getItem("profession") === "accountant") {
                formData.append("accountant", employee.url);
            } else {
                formData.append("manager", employee.url);
            }
            await Api.createNotificationComment(formData)
            await getNotificationByIdFunc()

            setFile("");
            setFilePreviewUrl("");
            setComment("");

        }
    };
    const handleKeyDown = async (e) => {
        if (e.key === 'Enter') {
            await sendComment();
        }
    };
    const handleFileChange = (e) => {
        const reader = new FileReader();
        const file = e.target.files[0];

        if (!file || file.size === 0) {
            alert("Ֆայլը դատարկ է");
            return;
        }

        reader.onloadend = () => {
            setFile(file);
            setFilePreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
    };
    const renderFilePreview = () => {
        if (filePreviewUrl !== "" && file) {
            try {
                return (
                    <div className='my-sms'>
                        <i className="far fa-times-circle"
                           onClick={() => {
                               setFile("");
                               setFilePreviewUrl("");
                           }}/>
                        {file.type.includes('image/') &&
                        <div className='my-sms-img'
                             style={{backgroundImage: `url(${filePreviewUrl})`}}/>
                        }
                        <span className='my-sms-img-name'>{file.name}</span>
                    </div>
                );
            } catch (error) {
                console.log('Error rendering preview:', error);
            }
        }
        return null;
    };
    return (
        <Wrapper>
            <div className='recommendation-page'>
                <Row>
                    <Col xs={12} sm={12}>
                        <a onClick={() => navigate(-1)} className="link-Backward-arrow">
                            <span className="icon-Backward-arrow"/>
                        </a>
                        <div className='company-name'
                             onClick={() => navigate(`/main_employee/organization/${data.company_id}`)}>
                            {data.company_name}
                        </div>
                        <h1>{data.title}</h1>
                        <p>{data.description}</p>

                        <div className="accountant-name-list">
                            <span className="accountant-name-list-title">Ուղարկված է</span>
                            {data.accountant_list?.map((item, index) => (
                                <div key={index} className="notification-accountant-name">
                                    {item.fullname}
                                    {(item.fullname.endsWith("ա") || item.fullname.endsWith("ո")) ? "յին" : "ին"},
                                </div>
                            ))}
                        </div>

                        <p className="end-date">{moment(data.date).format('LL')}</p>

                        <div className='img-cont'>
                            {data.notification_file?.map((item, index) => (
                                <div className='img' key={index} onClick={() => raiseInvoiceClicked(item.file)}>
                                    <span className='icon-Photos'/>
                                    <span className='phoro-name'>{item.file_name}</span>
                                </div>
                            ))}
                        </div>

                        <div className="comment-cont">
                            <h5 className="comment-heading">Մեկնաբանություն</h5>
                            <div className="image-input">
                                <img className="image" src={employee.image || user} alt="img"/>
                                <div className='input-image'>
                                    <div>{renderFilePreview()}</div>
                                    <input value={comment} onChange={(e) => setComment(e.target.value)}
                                           autoFocus onKeyDown={handleKeyDown}/>
                                </div>
                                <div className="send-file">
                                    <label>
                                        <i className="fas fa-image"/>
                                        <input type="file" className='input-icon' onChange={handleFileChange}/>
                                    </label>
                                    <img alt="img" className="send-icon" src={send} onClick={sendComment}/>
                                </div>
                            </div>

                            <div className="comment-item" ref={chatContainer}>
                                {data.notification_comment?.map((item, index) => {
                                    const employeeItem = item.comment_accountant || item.comment_manager;
                                    const myComment = (employee.url === item.accountant || employee.url === item.manager);
                                    return (
                                        <div key={index}
                                             className={myComment ? "my-comment-image comment-image" : "comment-image"}>
                                            <img className="image" src={employeeItem.image || user} alt="img"/>
                                            <div className="comment" style={myComment ? {alignItems: 'flex-end'} : {}}>
                                                <span>{`${employeeItem.user.first_name} ${employeeItem.user.last_name}`}</span>
                                                <div className='created_date'
                                                     style={!myComment ? {left: 1} : {}}>{moment(item.created_date).format('lll')}</div>
                                                {item.comment && <div className="comment-text">{item.comment}</div>}
                                                {item.file_url ? (
                                                    item.file_url.match(/\.(jpg|png|jpeg)$/)
                                                        ? <div className='sms-img'
                                                               onClick={() => raiseInvoiceClicked(item.file_url)}
                                                               style={{backgroundImage: `url(${item.file_url})`}}/>
                                                        : <div className="sms-url"
                                                               onClick={() => raiseInvoiceClicked(item.file_url)}>
                                                            {item.file_name !== "undefined" ? item.file_name : ""}
                                                        </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

        </Wrapper>
    );
}

export default NotificationPage;